import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { APP_CONFIG } from '@/config/app.config';

// Routes with no breadcrumb config (public screens, pages without a crumb).
const PAGE_TITLES: Record<string, string> = {
  '/login': 'Sign in',
  '/callback': 'Signing in',
  '/invitation': 'Invitation',
  '/invite-only': 'Invite only',
  '/invites': 'Invites',
};

/**
 * Sets the browser tab title to "{page} - {APP_NAME}". The page name is the
 * current breadcrumb label (so site pages pick up the site's dynamic name),
 * falling back to PAGE_TITLES, then to the bare brand.
 */
export function DocumentTitle() {
  const { pathname } = useLocation();
  const crumbs = useBreadcrumbs();
  const firstSegment = `/${pathname.split('/')[1] ?? ''}`;
  const page = crumbs[crumbs.length - 1]?.label ?? PAGE_TITLES[pathname] ?? PAGE_TITLES[firstSegment];

  useEffect(() => {
    document.title = page ? `${page} - ${APP_CONFIG.APP_NAME}` : APP_CONFIG.APP_NAME;
  }, [page]);

  return null;
}
